import { render, staticRenderFns } from "./About-us.vue?vue&type=template&id=4b822868&scoped=true"
import script from "./About-us.vue?vue&type=script&lang=js"
export * from "./About-us.vue?vue&type=script&lang=js"
import style0 from "./About-us.vue?vue&type=style&index=0&id=4b822868&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b822868",
  null
  
)

export default component.exports